
import {Box,Button,TextField,useMediaQuery,Autocomplete} from "@mui/material";
import {useState} from "react";
import { useSelector } from "react-redux";
import { requester } from "api/pesabackend";

const PurchaseRequistionDetailForm = (props) => {

    const {index, 
        data,
        handleRemoveProductDetailRow, 
        name, 
        errors,
        touched,
        handleBlur,
        handleChange,
        setFieldValue
        } = props;
    const isNonMobile = useMediaQuery("(min-width:600px)");
    
    const [productList, setProductList] = useState(data.product_info ? [data.product_info] : []);
    const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
    
    const [currentStock, setCurrentStock] = useState(data.quantity_remaining_at_requisition ? data.quantity_remaining_at_requisition : 0);
    const [monthSales, setMonthSales] = useState(data.quantity_sold_in_30_days ? data.quantity_sold_in_30_days : 0);
    const [lastPurchasePrice, setLastPurchasePrice] = useState(data.last_purchase_unit_price ? data.last_purchase_unit_price : 0);
    const [totalCost, setTotalCost] =useState(data.total_amount);
    const [relatedUnit, setRelatedUnit] = useState(data.related_product_unit)
    
    const handleChangeTotalAmount = (quantity) => {
      setTotalCost(Number(lastPurchasePrice)*Number(quantity));
    }

    const fetchItemStats = async (productId) => {
        try {
            const response = await requester.get(`/inventory/products/stats/${productId}`);
            setMonthSales(response.data.data.quantity_sold_in_last_30_days);
            setCurrentStock(response.data.data.available_stock);
            setLastPurchasePrice(response.data.data.last_unit_purchase_price[0].smallest_unit_unit_cost);
            setRelatedUnit(response.data.data.smallest_unit_detail.related_business_product_unit.name)
        } catch (e) {
        }
    };
     
    const fetchItemList = async (search) => {
        try {
            if (search){
                const response = await requester.get(
                  `/inventory/products/list?business_branch=${business_branch_id}&search=${search}&typeFilter=all`
                );
                setProductList(response.data.data);
            } else {
                const response = await requester.get(
                  `/inventory/products/list?business_branch=${business_branch_id}&typeFilter=all`
                );
                setProductList(response.data.data);
            }
            
        } catch (e) {
        }
    };
    
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Box>
          <p>#{index + 1}</p>
        </Box>
        <Box
          display="grid"
          gap="5px"
          p="0.5rem"
          gridTemplateColumns="repeat(14, minmax(0, 1fr))"
          sx={{
            "& > div": { gridColumn: isNonMobile ? undefined : "span 10" }, width:"100%"
          }}
        >
          <>
            <Autocomplete
              size="small"
              onOpen={() => {
                fetchItemList(null);
              }}
              name={`${name}.related_product`}
              onChange={(e, value) => {
                if (value) {
                  // fetchUnitForGivenItem(value.id);
                  // fetchCurrentStockForGivenItem(value.id);
                  fetchItemStats(value.id);
                }
                setFieldValue(
                  `${name}.related_product`,
                  value ? value.id : ''
                );
                setFieldValue(`${name}.related_product_unit`, '');
              }}
              sx={{ gridColumn: "span 3" }}
              options={productList}
              defaultValue={productList[0]}
              getOptionLabel={(option) =>
                `${option.product_name}  ${option.description}`
              }
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderOption={(props, productList) => (
                <Box
                  component="li"
                  sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                  {...props}
                  key={productList.id}
                >
                  {productList.product_name} {productList.description}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  inputProps={{
                    ...params.inputProps,
                  }}
                  label="Item Name"
                  value={
                    data.related_product ? data.related_product ?? null : ""
                  }
                  error={
                    Boolean(
                      touched?.products_requisitioned &&
                        touched?.products_requisitioned[index]?.related_product
                    ) &&
                    Boolean(
                      errors?.products_requisitioned &&
                        errors?.products_requisitioned[index]?.related_product
                    )
                  }
                  helperText={
                    touched?.products_requisitioned &&
                    touched?.products_requisitioned[index]?.related_product &&
                    errors?.products_requisitioned &&
                    errors?.products_requisitioned[index]?.related_product
                  }
                  onBlur={handleBlur}
                  onChange={(e) => {
                    fetchItemList(e.currentTarget.value);
                  }}
                />
              )}
            />

            <TextField
              label="Quantity on Hand"
              size="small"
              type="number"
              disabled
              onBlur={handleBlur}
              onChange={(e) => {
                handleChange(e);
              }}
              value={(data.quantity_remaining_at_requisition = currentStock)}
              name={`${name}.quantity_remaining_at_requisition`}
              error={
                Boolean(
                  touched?.products_requisitioned &&
                    touched?.products_requisitioned[index]?.quantity_remaining_at_requisition
                ) &&
                Boolean(
                  errors?.products_requisitioned &&
                    errors?.products_requisitioned[index]?.quantity_remaining_at_requisition
                )
              }
              helperText={
                touched?.products_requisitioned &&
                touched?.products_requisitioned[index]?.quantity_remaining_at_requisition &&
                errors?.products_requisitioned &&
                errors?.products_requisitioned[index]?.quantity_remaining_at_requisition
              }
              sx={{ gridColumn: "span 1" }}
            />

            <TextField
              label="Quantity Sold in 1 month"
              size="small"
              type="number"
              disabled
              onBlur={handleBlur}
              onChange={(e) => {
                handleChange(e);
              }}
              value={(data.quantity_sold_in_30_days = monthSales)}
              name={`${name}.quantity_sold_in_30_days`}
              error={
                Boolean(
                  touched?.products_requisitioned &&
                    touched?.products_requisitioned[index]
                      ?.quantity_sold_in_30_days
                ) &&
                Boolean(
                  errors?.products_requisitioned &&
                    errors?.products_requisitioned[index]
                      ?.quantity_sold_in_30_days
                )
              }
              helperText={
                touched?.products_requisitioned &&
                touched?.products_requisitioned[index]
                  ?.quantity_sold_in_30_days &&
                errors?.products_requisitioned &&
                errors?.products_requisitioned[index]
                  ?.quantity_sold_in_30_days
              }
              sx={{ gridColumn: "span 2" }}
            />

            <TextField
              label="Quantity Requisitioned"
              size="small"
              type="number"
              onBlur={handleBlur}
              onChange={(e)=>{
                handleChange(e);
                handleChangeTotalAmount(e.target.value);
              }}
              value={data.quantity_requisitioned}
              name={`${name}.quantity_requisitioned`}
              error={
                Boolean(
                  touched?.products_requisitioned &&
                    touched?.products_requisitioned[index]?.quantity_requisitioned
                ) &&
                Boolean(
                  errors?.products_requisitioned &&
                    errors?.products_requisitioned[index]?.quantity_requisitioned
                )
              }
              helperText={
                touched?.products_requisitioned &&
                touched?.products_requisitioned[index]?.quantity_requisitioned &&
                errors?.products_requisitioned &&
                errors?.products_requisitioned[index]?.quantity_requisitioned
              }
              sx={{ gridColumn: "span 2" }}
            />

            <TextField
              label="Last Unit Cost"
              size="small"
              type="number"
              disabled
              onBlur={handleBlur}
              onChange={handleChange}
              value={(data.last_purchase_unit_price=lastPurchasePrice)}
              name={`${name}.last_purchase_unit_price`}
              error={
                Boolean(
                  touched?.products_requisitioned &&
                    touched?.products_requisitioned[index]?.last_purchase_unit_price
                ) &&
                Boolean(
                  errors?.products_requisitioned &&
                    errors?.products_requisitioned[index]?.last_purchase_unit_price
                )
              }
              helperText={
                touched?.products_requisitioned &&
                touched?.products_requisitioned[index]?.last_purchase_unit_price &&
                errors?.products_requisitioned &&
                errors?.products_requisitioned[index]?.last_purchase_unit_price
              }
              sx={{ gridColumn: "span 1" }}
            />

            <TextField
              label="Item Unit"
              size="small"
              onBlur={handleBlur}
              onChange={handleChange}
              disabled
              value={(data.related_product_unit=relatedUnit)}
              name={`${name}.related_product_unit`}
              error={
                Boolean(
                  touched?.products_requisitioned &&
                    touched?.products_requisitioned[index]?.related_product_unit
                ) &&
                Boolean(
                  errors?.products_requisitioned &&
                    errors?.products_requisitioned[index]?.related_product_unit
                )
              }
              helperText={
                touched?.products_requisitioned &&
                touched?.products_requisitioned[index]?.related_product_unit &&
                errors?.products_requisitioned &&
                errors?.products_requisitioned[index]?.related_product_unit
              }
              sx={{ gridColumn: "span 2" }}
            />

            <TextField
              label="Total Cost"
              size="small"
              type="number"
              inputProps={{
                min: 0,
              }}
              disabled
              onBlur={handleBlur}
              onChange={handleChange}
              value={data.total_amount=totalCost}
              name={`${name}.total_amount`}
              error={
                Boolean(
                  touched?.products_requisitioned &&
                    touched?.products_requisitioned[index]?.total_amount
                ) &&
                Boolean(
                  errors?.products_requisitioned &&
                    errors?.products_requisitioned[index]?.total_amount
                )
              }
              helperText={
                touched?.products_requisitioned &&
                touched?.products_requisitioned[index]?.total_amount &&
                errors?.products_requisitioned &&
                errors?.products_requisitioned[index]?.total_amount
              }
              sx={{ gridColumn: "span 1" }}
            />

            {index > 0 ? (
              <Button
                value={index}
                onClick={() => {
                  handleRemoveProductDetailRow(index);
                }}
                size="small"
                variant="contained"
                sx={{
                  width: "20%",
                }}
              >
                Remove
              </Button>
            ) : null}
          </>
        </Box>
      </Box>
    );
  };
  
  export default PurchaseRequistionDetailForm;
  